import { Navigate, Outlet } from "react-router-dom";
import { useParams, useLocation } from "react-router";

import { UserValidator, setGlobalState, get_search_parameters } from "functions";
import Nav from "pages/generic_components/navbar.js";

export default function AdminRoutes() {
	let params = Object.assign(get_search_parameters(), useParams());
	setGlobalState("params", params);
	let location = useLocation();
	setGlobalState("location", location);

	let checker = new UserValidator();
	let is_staff = checker.is_staff();

	return is_staff ? (
		<div>
			<Nav />
			<Outlet />
		</div>
	) : (
		<Navigate to="/" />
	);
}
